import { contentfulImageLoader } from "@utils/imageLoader";
import React, { FC } from "react";

import Image from "@/components/ui/Image/Image";

import { CardWidthModal } from "./VerticalCardSlideShow";

const CardVerticalSlider: FC<CardWidthModal> = (cardData) => {
  const src = cardData?.image?.url;
  const srcSet = src ? [300, 400, 600, 800].map((w) => `${contentfulImageLoader({ src, width: w, quality: 80 })} ${w}w`).join(", ") : undefined;

  return (
    <div className="md:w-full md:relative aspect-3-4 md:rounded-md md:overflow-hidden">
      <img
        alt={cardData?.image?.title || ""}
        className="rounded aspect-3-4 shadow-strong h-full w-full object-cover"
        src={contentfulImageLoader({ src: src || "", width: 400, quality: 80 })}
        srcSet={srcSet}
        sizes="(min-width: 1024px) calc((100vw - 96px) / 4), calc(100vw / 1.3)"
        loading="lazy"
        decoding="async"
      />
      <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-2"></div>
      <Image
        className="absolute mx-auto left-1/2 transform -translate-x-1/2 bottom-m filter invert w-[100px] h-[80px] "
        src={cardData?.logo?.url}
        alt={cardData?.logo?.title}
        width={100}
        height={80}
        fit="pad"
      />
    </div>
  );
};
export default CardVerticalSlider;
